import { ELSCommonUIConstants } from 'components/common';
import { analyticBaseConfig } from 'config/app.config';
import { ROUTE_ROLES } from 'constants/app.constant';
import { lazy } from 'react';
import { EHR_PRODUCT_NAME, ehrPath } from 'reports/ehr/constants/ehr.constant';
var INSTRUCTOR = ROUTE_ROLES.INSTRUCTOR;
export var EhrRoutes = {
    getRoutes: function () { return [
        {
            path: ehrPath.ehrStudentDetail,
            component: lazy(function () { return import(/* webpackChunkName: "EHRStudentDetail" */ 'reports/ehr/components/pages/ehr-student-detail/EHRStudentDetail'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":ehr-student-detail"),
                    pageProductName: EHR_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: ehrPath.ehrHome,
            component: lazy(function () { return import(/* webpackChunkName: "EHRHome" */ 'reports/ehr/components/pages/ehr-home/EHRHome'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":ehr-dashboard"),
                    pageProductName: EHR_PRODUCT_NAME
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        }
    ]; }
};
